import React from "react";
import styles from "./index.module.css";

export function LoadingAnimation() {
    return <div className={styles.loading_animation}></div>;
}

export function LoadingAnimationContainer() {
    return <div className="flex w-full mt-16 justify-center">
        <LoadingAnimation/>
    </div>;
}